import { Box, Typography } from '@mui/material';
import PlusIcon from 'assets/add-white.svg';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import CustomTab from 'components/shared/CustomTab/CustomTab';
import { LayoutSwitcher } from 'components/shared/LayoutSwitcher';
import SearchInput from 'components/shared/SearchInput';
import { useInputWithDebounce } from 'customHook/useInputWithDebounce';
import { LayoutType } from 'model/deals.model';
import { SyntheticEvent, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { setAdminSearchModal, setSearchTerm, setTabValue } from 'store/slices/businessesSlice';
import { styles } from './styles';

export const Filters = ({
  layout,
  onLayoutChange,
}: {
  layout: LayoutType;
  onLayoutChange: (_: SyntheticEvent, newValue: LayoutType) => void;
}) => {
  const dispatch = useAppDispatch();
  const { allBusinessCount, searchTerm, tabValue } = useAppSelector((state) => state.businesses);
  const { value, debouncedValue, handleChange, clearInput } = useInputWithDebounce(searchTerm, 500);
  const role = useAppSelector((state) => state.auth.role);
  const isAdmin = role?.includes('');

  useEffect(() => {
    dispatch(setSearchTerm(debouncedValue));
  }, [debouncedValue, dispatch]);

  const tabs = [
    {
      label: `All Businesses (${allBusinessCount})`,
      id: 1,
      isHidden: tabValue !== 0,
      Component: <></>,
    },
  ];

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    dispatch(setTabValue(newValue));
  };

  const handleNewBusinessClick = () => {
    dispatch(setAdminSearchModal(true));
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '16px',
        }}
      >
        <Box>
          <CustomTab tabs={tabs} handleChange={handleTabChange} value={tabValue} />
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
            gap: { xs: '8px', sm: '12px' },
            alignItems: 'center',
          }}
        >
          <Box sx={{ width: { xl: '240px', xs: '150px' } }}>
            <SearchInput value={value} handleChange={handleChange} clearInput={clearInput} />
          </Box>

          <LayoutSwitcher layout={layout} onLayoutChange={onLayoutChange} />

          {isAdmin && (
            <CustomButton
              icon={<img src={PlusIcon} alt='white arrow' />}
              iconPosition='start'
              variant={'contained'}
              text={<Typography variant='responsiveButtonMedium'>New Business</Typography>}
              style={{ ...styles.button }}
              onClick={handleNewBusinessClick}
              disabled={false}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
